
import { Component, Prop, Vue } from 'vue-property-decorator';
import ProductSegmentBuilder from '@/components/ProductSegmentBuilder.vue';
import HeaderTitle from '@/components/HeaderTitle.vue';
import { TemplateReportList } from '@/collections/template_reports';
import { MeasureList } from '@/collections/measures';
import { StoreModel } from '@/models/store';
import TryNewAtlasBanner from '@/components/TryNewAtlasBanner.vue';
import { getFeatureVersion, setFeatureVersion, productSegmentSwitchTarget } from '@/config/atlasFeatures';

@Component({
  components: {
    ProductSegmentBuilder,
    HeaderTitle,
    TryNewAtlasBanner,
  },
})
export default class ProductSegmentExplore extends Vue {
  @Prop({ default: () => new StoreModel() })
  public store!: StoreModel;
  @Prop({ default: false })
  public enableAthena!: boolean;
  @Prop({ default: false })
  public isDataReady!: boolean;
  @Prop({ default: false })
  public isAthenaReady!: boolean;
  @Prop({ default: false })
  public isAthenaFinished!: boolean;
  @Prop({ default: () => [] })
  public timeRangeLimit!: string[];
  @Prop({ default: 'available' })
  public isLockedReports!: string;
  @Prop({ default: false })
  public hasSchemas!: boolean;
  @Prop({ default: () => new TemplateReportList() })
  public templateReports!: TemplateReportList;
  @Prop({ default: () => new MeasureList() })
  public measures!: MeasureList;

  get showTryNewProductSegmentsBanner(): boolean {
    return getFeatureVersion('productSegments') === 'classic';
  }

  public switchProductSegmentsToAtlas(): void {
    setFeatureVersion('productSegments', 'atlas');
    this.$router.push(productSegmentSwitchTarget('segmentExplore'));
  }

  public navigateToListing() {
    this.$router.push('/product-segment');
  }
}
